import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { generateFilterOptions } from 'utils';
import { Autocomplete } from 'components/FormFields';
import { timeZones as timeZonesList } from 'constants';

const TimezoneSelect = ({
  label,
  margin,
  variant,
  field: { name, value },
  loading,
  country,
  form: { errors, touched, setFieldValue },
}) => {
  const [defaultValue, setDefaultValue] = useState(null);
  const filterOptions = generateFilterOptions('start', 'label');
  let timezones = [];
  if (country) {
    timezones = [...timeZonesList[country.toLowerCase()]];
  } else {
    timezones = [];
    Object.keys(timeZonesList).forEach((key) => {
      timezones = [...timezones, ...timeZonesList[key]];
    });
  }
  useEffect(() => {
    if (value || value === '') {
      const defaultVal = timezones.find((el) => el.value === value);
      if (defaultVal) {
        setDefaultValue(defaultVal);
      } else {
        setDefaultValue(null);
      }
    }
  }, [value, timezones]) // eslint-disable-line

  return (
    <Autocomplete
      label={label}
      margin={margin}
      fullwidth="true"
      variant={variant}
      loading={loading}
      options={timezones}
      filterOptions={filterOptions}
      id="timezoneSelect"
      value={defaultValue}
      getOptionLabel={(option) => option.label || ''}
      error={errors && errors[name] && touched && touched[name]}
      onChange={(ev, val) => setFieldValue(name, val?.value || '')}
      getOptionSelected={(option, value) => option.value === value.value}
      helperText={errors && errors[name] && touched && touched[name] && errors[name]}
    />
  );
};

TimezoneSelect.propTypes = {
  loading: PropTypes.bool,
  label: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  field: PropTypes.shape({
    value: PropTypes.any,
    name: PropTypes.string,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
  }),
  form: PropTypes.shape({
    errors: PropTypes.object,
    touched: PropTypes.object,
  }),
  customParams: PropTypes.object,
  variant: PropTypes.oneOf(['standard', 'outlined', 'filled']),
};

TimezoneSelect.defaultProps = {
  loading: false,
  required: true,
  disabled: false,
  form: {
    errors: {},
    touched: {},
  },
  customParams: {},
  variant: 'standard',
  placeholder: 'Select...',
};

export default TimezoneSelect;
